module.exports = __webpack_public_path__ + "static/media/plans_bg.3f6f5ddb.svg";